/* eslint-disable no-restricted-imports */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { calculateProductPriceIncrease } from '@/data/Content/BasicCheckOut/utils/calculateProductPriceIncrease';
import { Price, ProductType } from '@/data/types/Product';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { extractNumberFromString } from 'integration/utils/calculateProductPrices';
import { formatPrice } from 'integration/utils/formatPrice';
import { FC, useMemo } from 'react';

interface InfoElectronico {
	offerDeContado?: string;
	strikedDeContado?: string;
}

export const productSearchPriceSX = (hasDiscount: boolean): SxProps<Theme> => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-body)',
	fontWeight: '600',
	textDecoration: hasDiscount ? 'line-through' : 'none',
});

export const productSearchDiscountSX: SxProps<Theme> = {
	color: '#AB2326',
	fontSize: 'var(--font-size-body)',
	fontWeight: '600',
	marginRight: '8px',
	textDecoration: 'none',
};

export const PriceProductSearch: FC<{
	product: ProductType;
	infoElectronico?: InfoElectronico;
}> = ({ product, infoElectronico }) => {
	const { discount, price } = useMemo(() => {
		if (infoElectronico) {
			return {
				discount: infoElectronico.strikedDeContado
					? formatPrice(infoElectronico.offerDeContado || '', 'MXN')
					: null,
				price: formatPrice(
					infoElectronico.strikedDeContado || infoElectronico.offerDeContado || '',
					'MXN'
				),
			};
		}

		const rawPrice: Price = product.price.filter((item: Price) => item.usage === 'Display')[0];
		const rawDiscount: Price = product.price.filter((item: Price) => item.usage === 'Offer')[0];

		const listPrice = Number(rawPrice.value);
		const offerPrice = Number(rawDiscount.value);

		const withAdditinalOffer = product.ribbons.find((ribbon) => ribbon.identifier === 'DPT_Oferta');
		const discoundNumber = extractNumberFromString(withAdditinalOffer?.value ?? '');
		const newOffer = offerPrice - (offerPrice * discoundNumber) / 100;

		// Si el precio de oferta es diferente al de lista, tiene descuento
		const discount = newOffer !== listPrice ? formatPrice(newOffer, rawDiscount.currency) : null;
		const price = formatPrice(calculateProductPriceIncrease(rawPrice.value), rawPrice.currency);

		return { discount, price };
	}, [product.price, infoElectronico, product.ribbons]);

	return (
		<Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'}>
			{/* {discount ? <Typography sx={productSearchDiscountSX}>{discount}</Typography> : null} */}
			<Typography sx={productSearchPriceSX(false)}>{price}</Typography>
		</Box>
	);
};
